import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import db from '@/utils/localStorage';
import { getHashSearchParam } from '@/utils/fn';

Vue.use(Router);
const files = require.context('.', false, /\.js$/)
const modules = []

files.keys().forEach(key => {
  if (key === './index.js' || key === './toggel.js') return
  modules.push(...files(key).default)
});
const router = new Router({
  // mode: "history",
  routes: [
    {
      path: '',
      name: 'global',
      component: () => import('@/views/Global'),
      children: [

        {
          path: '/',
          name: 'home',
          component: () => import('@/views/Home'),
          children: [
            {
              path: 'schedule',
              name: 'Schedule',
              component: () => import('@/views/Schedule'),
            },
            {
              path: 'player',
              name: 'Player',
              component: () => import('@/views/Player'),
            },
            {
              path: 'integral',
              name: 'Integral',
              component: () => import('@/views/Integral'),
            },
            {
              path: '',
              redirect: 'schedule'
            }
          ]
        },

        ...modules,

        {
          path: '/expired',
          name: 'Expired',
          component: () => import('@/views/Expired'),
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Expired') {
    return next()
  }
  const token = getHashSearchParam('token') || db.get('token', '')
  const apiSrc = getHashSearchParam('apiSrc') || db.get('apiSrc', '')
  if ((token && token != 'null') && (apiSrc && apiSrc != 'null')) {
    store.commit('common/SET_TOKEN', token)
    const nickname = getHashSearchParam('nickname') || db.get('nickname', '')
    if (nickname) {
      store.commit('common/SET_NICKNAME', nickname)
    }
    next()
  } else {
    // 没有token，阻止导航
    next(false)
  }
});



export default router;
